import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Hospital = {
  id: string;
  name: string;
  logoUrl?: string;
  colorTheme?: string;
  parentId?: string | null;
  image?: string;
  isSlave?: boolean;
  isRoot?: boolean;
  slave?: boolean;
  hospitalImage?: string;
  hospitalBackground?: string;
  firebaseToken?: string;
  clinicNetworkRole?: "root" | "brand" | "site" | string;
  /** True when this account is in hospital_master. */
  inHierarchy?: boolean;
};

type HospitalState = {
  current: Hospital | null;
  list: Hospital[];
  contextVersion: number;
};

const persisted = (() => {
  try {
    const raw = localStorage.getItem("current-hospital");
    const result = raw ? JSON.parse(raw) : null;
    return result;
  } catch {
    return null;
  }
})();

const persistedList = (() => {
  try {
    const raw = localStorage.getItem("hospitals-list");
    const result = raw ? JSON.parse(raw) : [];
    /* console.log(
      "💾 REDUX-INIT: Persisted hospital list from localStorage:",
      result,
    );*/
    return result;
  } catch {
    /*  console.log(
      "💾 REDUX-INIT: Error parsing persisted hospital list, returning empty array",
    );*/
    return [];
  }
})();

const initialState: HospitalState = {
  current: persisted,
  list: persistedList,
  contextVersion: 0,
};

const slice = createSlice({
  name: "currentHospital",
  initialState,
  reducers: {
    setHospitals(state, action: PayloadAction<Hospital[]>) {
      state.list = action.payload;
      // Persist hospital list to localStorage with timestamp
      try {
        localStorage.setItem("hospitals-list", JSON.stringify(action.payload));
        localStorage.setItem("hospitals-list-timestamp", Date.now().toString());
      } catch {}

      if (!state.current && action.payload.length > 0) {
        state.current = action.payload[0];
        localStorage.setItem("current-hospital", JSON.stringify(state.current));
      }
    },
    setCurrentHospital(state, action: PayloadAction<Hospital>) {
      state.current = action.payload;
      state.contextVersion++;
      try {
        localStorage.setItem(
          "current-hospital",
          JSON.stringify(action.payload),
        );
        localStorage.setItem(
          "current-hospital-info",
          JSON.stringify({
            id: action.payload.id,
            name: action.payload.name,
          }),
        );
      } catch {}
    },
    clearHospitals(state) {
      state.list = [];
      state.current = null;
      state.contextVersion++;
      try {
        localStorage.removeItem("hospitals-list");
        localStorage.removeItem("hospitals-list-timestamp");
        localStorage.removeItem("current-hospital");
      } catch {}
    },
    bumpContext(state) {
      state.contextVersion++;
    },
  },
});

export const { setHospitals, setCurrentHospital, clearHospitals, bumpContext } =
  slice.actions;
export default slice.reducer;
